import { render, staticRenderFns } from "./document-signer.vue?vue&type=template&id=40b3099e&"
import script from "./document-signer.vue?vue&type=script&lang=js&"
export * from "./document-signer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "document-signer.vue"
export default component.exports